import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const Companylist = () => {
    
    const [companies, setCompany] = useState([]);
    // Access the environment variables
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    useEffect(() => {
        getCompany();
    }, []);

    const getCompany = async () => {
        const response = await axios.get(`${API_BASE_URL}/companies`, {
            headers: {
                'X-API-Key': API_KEY
            },
        });
        setCompany(response.data);
    };

    const deleteCompany = async (companyId) => {
        if (window.confirm('Are you sure you want to delete this item?')) {
            await axios.delete(`${API_BASE_URL}/companies/${companyId}`);
            getCompany();
        } else {
            return
        }   
    };

    return (
        <div className="container">
            <div className="columns">
                <div className="column is-centered">
                    <h1 className="title is-size-5">Data Company</h1>
                    <div className="columns">
                        <div className="column is-1">
                        <Link to="/companies/add" className="button is-small is-primary">
                            Add New
                        </Link>
                        </div>
                    </div>
                    <table className="table is-striped is-fullwidth is-size-7">
                        <thead>
                        <tr>
                            <th>No</th>
                            <th className="has-text-centered">Actions</th>
                            <th>Logo</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Fax</th>                            
                        </tr>
                        </thead>
                        <tbody>
                        {companies.map((company, index) => (
                            <tr key={company.uuid}>
                            <td>{index + 1}</td>
                            <td className="has-text-centered">
                                <div className="is-inline-flex">
                                <Link
                                    to={`/companies/edit/${company.uuid}`}
                                    className="button is-small is-info mr-1"
                                >
                                    Edit
                                </Link>
                                <button
                                    onClick={() => deleteCompany(company.uuid)}
                                    className="button is-small is-danger"
                                >
                                    Delete
                                </button>
                                </div>
                            </td>
                            <td>
                                <figure className="image is-4by3">
                                <img src={company.url} alt="Image" />
                                </figure>
                            </td>
                            <td>{company.name}</td>
                            <td>{company.address}</td>
                            <td>{company.email}</td>
                            <td>{company.phone}</td>
                            <td>{company.fax}</td>
                            
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Companylist;
